import { ApiService } from "../service/ApiService";

export const fetchEntitiesByIds = async (entityIdList: string[], baseURL: string) => {
  const response = await ApiService.post<any>("bkper/entity/by-ids", entityIdList, { baseURL });
  return response.data || [];
};


export const mapEntitiesToDropdown = (rowData: any[]) =>
  rowData
    .map((entity) => ({
      value: entity.bookId,
      title: entity.entityName,
    }))
    .sort((a, b) => a.title.localeCompare(b.title));


export const buildShareholderOptions = (rowData: any[], investments: any[]) => {
  const options: any[] = [];
  investments.forEach((inv) => {
    const matched = rowData.find((ent) => inv.entityId.toString() === ent.entityId);
    if (matched) {
      options.push({
        shareholderName: inv.shareholderName,
        bookId: matched.bookId,
        email: inv.shareholderEmail,
        shareholderId: inv.shareholderId,
        entityName: matched.entityName,
      });
    }
  });
  return options;
};


export const aggregateShareholderOptions = (
  shareholderOptions: any[],
  bookId: string,
) => {
  const matched = shareholderOptions.filter((o) => o.bookId === bookId);
  if (matched.length === 0) return null;
  const first = matched[0];
  return {
    shareholderName: matched.map((o) => o.shareholderName),
    email: matched.map((o) => o.email),
    shareholderId: matched.map((o) => o.shareholderId),
    bookId: first.bookId,
    entityName: first.entityName,
  };
};